import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {MainBox} from '../Dashboard/DashboardStyle'
import {ErrorBox, ErrorMsg, ErrorLink, ErrorMainStyle} from './ErrorComponentStyle'

const ErrorComponent = ({errorCode, errorMsg, isAdminPanelOpen}) => {
  return (
    <MainBox style={{marginTop: isAdminPanelOpen ? '60px' : '8px'}}>
      <ErrorMainStyle className='Error-main' data-testid='Error-main'>
        <ErrorBox>{errorCode}</ErrorBox>
        <ErrorMsg>{errorMsg}</ErrorMsg>
        <ErrorLink>
          {isAdminPanelOpen ? (
            <Link to='/adminpanel'>Go back to adminpanel dashboard </Link>
          ) : (
            <Link to='/'>Go back to main dashboard</Link>
          )}
        </ErrorLink>
      </ErrorMainStyle>
    </MainBox>
  )
}
ErrorComponent.propTypes = {
  errorCode: PropTypes.string,
  errorMsg: PropTypes.string,
  isAdminPanelOpen: PropTypes.bool
}
export default ErrorComponent

// ErrorComponent: Displays an error message with a code and a link to navigate back to the appropriate dashboard based on the admin panel state.
